/* jshint esnext: true */
import AbstractModule from './AbstractModule';
import { resizeApi } from '../utils/resize';

export default class extends AbstractModule {
    constructor (options) {
        super(options);
        this.resizeIdent = null;

        this.$frame = this.$el.find('.js-frame');
        this.$track = this.$el.find('.js-track');

        this.instance = this.initSly();

        setTimeout(() => {
            this.resize();
        }, 1000);

        this.$track.slickLightbox({
            caption: 'caption',
            background: ''
        });
    }

    initSly() {
        var options = {
            horizontal: 1,
            // itemNav: 'basic',
            itemNav: 'centered',
            smart: 1,
            // activateOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            // startAt: 0,
            scrollBar: this.$el.find('.js-scrollbar'),
            // scrollBy: 1,
            // activatePageOn: 'click',
            speed: 600,
            // elasticBounds: 1,
            easing: 'stadEasing',
            dragHandle: 1,
            dynamicHandle: 1,
            // clickBar: 1,
        };

        this.resizeIdent = resizeApi({
            action: 'addCallback',
            callback: () => {
                this.resize()
            }
        });

        return new Sly(this.$frame, options).init();
    }

    resize() {
        this.instance.reload();
    }

    destroy() {
        resizeApi({
            'action': 'removeCallback',
            'ident': this.resizeIdent
        });
        this.instance.destroy();
    }
}
